<template>
  <div class="w-full h-[26px] rounded-xl flex-center justify-between text-white"
       :style="{'background':cardType?.background}">
    <div class="w-[75%] h-[26px] rounded-xl pr-4 flex items-center ps-4"
         :style="{'background':cardType?.forgroundColor}">
      <div class="truncate">{{ content }}</div>
    </div>
    <div class="flex-center gap-2 pr-2 rtl:pl-2">
      <div class="font-medium text-white">{{ title }}</div>
      <niceone-image :src="$publicPath('/images/loyalty/badge/icon.svg')" width="18" height="14"/>
      <van-icon :name="$i18n.locale == 'en' ? 'arrow' : 'arrow-left'" :color="cardType.iconColor"/>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  type: {
    type: Number,
    default: 2
  },
  title: {
    type: String,
    default: ""
  },
  content: {
    type: String,
    default: ""
  }
});

const cardDesign = {
  1: {background: "#828282", color: "#fff", forgroundColor: '#504F4F33', iconColor: '#fff'},
  2: {background: "#CE9C3A", color: "#fff", forgroundColor: '#DAB162', iconColor: '#A17622'},
  3: {background: "#151515", color: "#fff", forgroundColor: '#272828', iconColor: '#fff'}
};
const cardType = computed(() => cardDesign[props.type]);
</script>
